var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_2864)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.6481C1.00008 11.4325 1.04448 11.2194 1.13044 11.0217C1.21641 10.8241 1.3421 10.6463 1.49971 10.4993L11.4893 1.18862C11.6316 1.06689 11.8127 1 12 1C12.1873 1 12.3684 1.06689 12.5107 1.18862L22.5003 10.4993C22.6579 10.6463 22.7836 10.8241 22.8696 11.0217C22.9555 11.2194 22.9999 11.4325 23 11.6481V20.6429C23 21.2681 22.7517 21.8676 22.3096 22.3097C21.8676 22.7517 21.268 23 20.6429 23H3.35714C2.73199 23 2.13244 22.7517 1.69039 22.3097C1.24834 21.8676 1 21.2681 1 20.6429L1 11.6481ZM11.6386 14.75H9.64914V10.0358H14.3634V14.75H11.6386ZM8.458 21.0358H11.2143V16.3215H6.5V21.0358H8.458ZM14.7783 21.0358H12.7857V16.3215H17.5V21.0358H14.7783Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_2864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseicon);
export default __webpack_public_path__ + "static/media/warehouse.icon.2261cc5ba64204378c42d917105879e7.svg";
export { ForwardRef as ReactComponent };